import { render, staticRenderFns } from "./resource-introduce.vue?vue&type=template&id=8653d9b4"
import script from "./resource-introduce.vue?vue&type=script&lang=js"
export * from "./resource-introduce.vue?vue&type=script&lang=js"
import style0 from "./resource-introduce.vue?vue&type=style&index=0&id=8653d9b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports